import * as React from 'react';

import TrackingDescription from 'containers/molecules/CardLayerTracking/fragments/TrackingDescription';
import { TrackingDescriptionID } from 'defs/tracking';

type CardLayerTrackingProps = {
	doRequestDescriptions: () => void;
};

class CardLayerTracking extends React.Component<CardLayerTrackingProps> {
	public static displayName = 'CardLayerTracking';

	public componentDidMount() {
		this.props.doRequestDescriptions();
	}

	public render() {
		return (
			<React.Fragment>
				<TrackingDescription id={TrackingDescriptionID.weight} />
				<TrackingDescription id={TrackingDescriptionID.waist} />
				<TrackingDescription id={TrackingDescriptionID.bodyFat} />
			</React.Fragment>
		);
	}
}

export default CardLayerTracking;
